// components/templates/sections/Collections.tsx
'use client';
import React from 'react';
import { useDesign } from '@/context/DesignContext';

interface Collection {
  title: string;
  sub: string;
  image: string;
}

interface CollectionsProps {
  items?: Collection[];
  title?: string;
  design?: any;
}

export default function Collections({ items, title, design: propDesign }: CollectionsProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  if (!items || items.length === 0) return null;

  const primaryColor = design?.colors?.primary || '#C8A96E';
  const textColor = design?.colors?.text || '#F5F5F5';
  const headingFont = design?.typography?.headingFont || "'Cormorant Garamond', serif";
  const bodyFont = design?.typography?.bodyFont || "'Inter', sans-serif";
  const borderRadius = design?.effects?.borderRadius || '2px';

  return (
    <section className="px-8 md:px-16 py-24">
      <div className="flex items-end justify-between mb-12">
        <div>
          <div className="text-xs uppercase tracking-widest mb-3" style={{ fontFamily: bodyFont, color: primaryColor }}>— Chapters</div>
          {title && <h2 className="font-serif text-5xl md:text-6xl font-light" style={{ fontFamily: headingFont, color: textColor }}>{title}</h2>}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {items.map((col, i) => (
          <div key={col.title} className="relative group" style={{ height: i === 1 ? 520 : 420, borderRadius }}>
            <img src={col.image} alt={col.title} className="w-full h-full object-cover" style={{ borderRadius }} />
            <div className="absolute inset-0" style={{ background: `linear-gradient(to top, ${design?.colors?.secondary || '#0F0F0F'}E6 0%, rgba(5,5,5,0.2) 60%, transparent 100%)`, borderRadius }} />
            <div className="absolute bottom-0 left-0 p-8">
              <div className="text-xs uppercase tracking-widest mb-2" style={{ fontFamily: bodyFont, color: primaryColor }}>{col.sub}</div>
              <div className="font-serif text-4xl font-light" style={{ fontFamily: headingFont, color: textColor }}>{col.title}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}